import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

const projectEnvironment = createApi({
    reducerPath: "ProjectEnvironment",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        getProjectEnvironmentById: builder.query({
            query: (projectId) => ({
                url: `ProjectEnvironment/GetAllProjectEnvironmentById?ProjectId=${projectId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteProjectEnvironmentById: builder.mutation({
            query: (environmentId) => ({
                url: `/ProjectEnvironment/DeleteProjectEnvironment?EnvironmentId=${environmentId}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addProjectEnvironment: builder.mutation({
            query:(data) => ({
                url: `/ProjectEnvironment/AddProjectEnvironment`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateProjectEnvironment: builder.mutation({
            query: (data) => ({
                url: '/ProjectEnvironment/UpdateProjectEnvironment',
                method: 'POST',
                body: transformRequest(data)
            }), 
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getProjectEnvironmentByEnvironmentId: builder.query({
            query: (environmentId) => ({
                url: `/ProjectEnvironment/GetProjectEnvironmentByEnvironmentId?environmentid=${environmentId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        
    })
})

export const {
    useLazyGetProjectEnvironmentByIdQuery,
    useDeleteProjectEnvironmentByIdMutation,
    useAddProjectEnvironmentMutation,
    useUpdateProjectEnvironmentMutation,
    useLazyGetProjectEnvironmentByEnvironmentIdQuery
} = projectEnvironment;

export default projectEnvironment;